(()=>{'use strict';const ready=new WeakSet();function init(root){if(ready.has(root))return;ready.add(root);const TOUR=JSON.parse(root.querySelector('[data-tour-data]').textContent);const {PHOTOS,FEATURES,JOURNEY,DAY_PHOTOS,DEPARTURES,GUIDES}=TOUR;for(const departure of Object.values(DEPARTURES)){if(departure.price!==null&&departure.price<=0){departure.price=null;departure.priceConfirmed=false;}const count=departure.availability.match(/(\d+)\s*spots?\s*left/i);if(count){departure.spotsLeft=Number(count[1]);departure.availability=departure.spotsLeft+' '+(departure.spotsLeft===1?'spot':'spots')+' left';}}

'use strict';





const $=s=>root.querySelector(s), $$=s=>Array.from(root.querySelectorAll(s));
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const motion=reduced?'auto':'smooth';


const imageObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){hydrateImage(entry.target);imageObserver.unobserve(entry.target);}}},{rootMargin:'500px'}):null;
function hydrateImage(img){
 if(!img.dataset.lazySrc)return;
 if(img.dataset.lazySrcset)img.srcset=img.dataset.lazySrcset;else img.removeAttribute('srcset');
 img.src=img.dataset.lazySrc;
 delete img.dataset.lazySrc;delete img.dataset.lazySrcset;
}
function watchImage(img){
 const box=img.getBoundingClientRect();
 if(!imageObserver||box.top<innerHeight+500&&box.bottom>-500&&box.left<innerWidth+500&&box.right>-500)hydrateImage(img);
 else imageObserver.observe(img);
}
function resized(src,width){
 try{const url=new URL(src,location.href);if(url.pathname.includes('/files/')&&!url.pathname.includes('/assets/')){url.searchParams.set('width',String(width));return url.href;}}catch(e){}
 return src;
}
function setPhoto(img,src,alt){
 if(!src){img.hidden=true;return;}img.hidden=false;img.alt=alt||'';img.loading='lazy';img.decoding='async';
 const full=img.id==='lb-image';const thumb=!full&&(img.width<=118||!!img.closest('#journey-thumbs'));
 const widths=thumb?[160,320]:full?[600,960,1400,2000,2400]:[320,600,960,1400,1800];
 const base=resized(src,thumb?320:full?2000:960);
 img.src=base;delete img.dataset.lazySrc;
 if(base!==src||/\/files\//.test(src)&&!/\/assets\//.test(src))img.srcset=widths.map(w=>resized(src,w)+' '+w+'w').join(',');else img.removeAttribute('srcset');delete img.dataset.lazySrcset;
 if(thumb)img.sizes='118px';else if(full)img.sizes='(max-width:760px) 100vw, 90vw';
 watchImage(img);
}
$$('img[data-lazy-src]').forEach(watchImage);
$$('img').forEach(img=>img.addEventListener('error',()=>{img.classList.add('image-failed');img.closest('.review-avatar')?.classList.add('image-failed');},{once:true}));

let guideIndex=0;
function showGuide(index,focus=false){
 guideIndex=(index+GUIDES.length)%GUIDES.length;const guide=GUIDES[guideIndex];
 $$('[data-guide]').forEach((button,i)=>{button.setAttribute('aria-selected',String(i===guideIndex));button.tabIndex=i===guideIndex?0:-1;});
 $('#guide-portrait-panel').setAttribute('aria-labelledby','guide-tab-'+guideIndex);
 $$('[data-guide-portrait]').forEach(img=>{img.removeAttribute('id');img.hidden=Number(img.dataset.guidePortrait)!==guideIndex;if(!img.hidden){img.id='guide-image';img.style.objectPosition=guide.position;}});const img=$('#guide-image');
 img.classList.remove('guide-portrait-change');void img.offsetWidth;img.classList.add('guide-portrait-change');
 $('#guide-photo-caption').textContent=guide.caption;
 if(focus)$('[data-guide="'+guideIndex+'"]').focus({preventScroll:true});
}
$$('[data-guide]').forEach(button=>button.addEventListener('click',()=>showGuide(Number(button.dataset.guide))));
addTabKeyboard('.guide-photo-tabs',()=>guideIndex,showGuide,GUIDES.length);
const highlightTrack=$('#highlights-track');
let highlightFrame=0;
function updateHighlightArrows(){
 highlightFrame=0;const max=Math.max(0,highlightTrack.scrollWidth-highlightTrack.clientWidth);
 $('#highlights-prev').disabled=highlightTrack.scrollLeft<3;
 $('#highlights-next').disabled=highlightTrack.scrollLeft>max-3;
}
function scrollHighlights(direction){
 const tile=highlightTrack.querySelector('.gallery-tile');const gap=parseFloat(getComputedStyle(highlightTrack).gap)||18;
 highlightTrack.scrollBy({left:direction*(tile.getBoundingClientRect().width+gap),behavior:motion});
}
$('#highlights-prev').addEventListener('click',()=>scrollHighlights(-1));
$('#highlights-next').addEventListener('click',()=>scrollHighlights(1));
highlightTrack.addEventListener('scroll',()=>{if(!highlightFrame)highlightFrame=requestAnimationFrame(updateHighlightArrows);},{passive:true});
highlightTrack.addEventListener('keydown',event=>{
 if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();scrollHighlights(event.key==='ArrowRight'?1:-1);}
 else if(event.key==='Home'||event.key==='End'){event.preventDefault();highlightTrack.scrollTo({left:event.key==='Home'?0:highlightTrack.scrollWidth,behavior:motion});}
});
if('ResizeObserver' in window)new ResizeObserver(updateHighlightArrows).observe(highlightTrack);
else window.addEventListener('resize',updateHighlightArrows,{passive:true});
updateHighlightArrows();

let featureIndex=0;
function showFeature(index,focus=false){featureIndex=(index+FEATURES.length)%FEATURES.length;const f=FEATURES[featureIndex];$$('[data-feature]').forEach((b,i)=>{b.setAttribute('aria-selected',String(i===featureIndex));b.tabIndex=i===featureIndex?0:-1;});$('#feature-panel').setAttribute('aria-labelledby','feature-tab-'+featureIndex);$('#feature-panel').dataset.featureActive=String(featureIndex);$$('[data-feature-photo]').forEach(img=>{img.removeAttribute('id');img.hidden=Number(img.dataset.featurePhoto)!==featureIndex;if(!img.hidden)img.id='feature-image';});$$('[data-feature-copy]').forEach(panel=>{panel.querySelector('h3').removeAttribute('id');panel.querySelector('.feature-richtext').removeAttribute('id');panel.hidden=Number(panel.dataset.featureCopy)!==featureIndex;if(!panel.hidden){panel.querySelector('h3').id='feature-title';panel.querySelector('.feature-richtext').id='feature-text';}});$('#feature-credit').textContent=f.label.toUpperCase()+' · '+TOUR.tourTitle.toUpperCase();if(focus){const b=$('[data-feature="'+featureIndex+'"]');b.focus({preventScroll:true});b.scrollIntoView({behavior:motion,block:'nearest',inline:'nearest'});}}

$$('[data-feature]').forEach(b=>b.addEventListener('click',()=>showFeature(Number(b.dataset.feature))));$('#feature-prev').addEventListener('click',()=>showFeature(featureIndex-1));$('#feature-next').addEventListener('click',()=>showFeature(featureIndex+1));
let dayIndex=0;
const dayPhotoIndices=JOURNEY.map(()=>0);
function makeDayThumbnails(){const tray=$('#journey-thumbs');tray.replaceChildren();DAY_PHOTOS[dayIndex].forEach((p,i)=>{
 const button=document.createElement('button');button.type='button';button.dataset.photo=String(i);button.setAttribute('aria-label','View photo '+(i+1)+': '+p.title);button.setAttribute('aria-pressed',String(i===dayPhotoIndices[dayIndex]));
 const image=document.createElement('img');image.alt='';image.width=118;image.height=98;image.loading='lazy';setPhoto(image,p.src,'');
 const number=document.createElement('span');number.textContent=String(i+1).padStart(2,'0');number.setAttribute('aria-hidden','true');button.append(image,number);button.addEventListener('click',()=>showDayPhoto(i));tray.append(button);
});}
function showDayPhoto(index){const list=DAY_PHOTOS[dayIndex];const i=(index+list.length)%list.length;dayPhotoIndices[dayIndex]=i;const p=list[i];
 setPhoto($('#journey-image'),p.src,p.alt);$('#journey-media').setAttribute('aria-label','Expand '+JOURNEY[dayIndex].days+', photograph '+(i+1)+' of '+list.length+': '+p.title);
 $('#journey-caption').textContent=JOURNEY[dayIndex].days.toUpperCase()+' · '+p.title;
 $$('[data-photo]').forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));
}
function showDay(index,focus=false){dayIndex=(index+JOURNEY.length)%JOURNEY.length;const d=JOURNEY[dayIndex];
 $$('[data-day]').forEach((b,i)=>{b.setAttribute('aria-selected',String(i===dayIndex));b.tabIndex=i===dayIndex?0:-1;});
 $('#journey-panel').setAttribute('aria-labelledby','journey-title');$('#journey-title').textContent=d.title;$('#journey-text').innerHTML=d.html||d.text;
 $('#journey-meta').replaceChildren(...d.meta.map(t=>{const span=document.createElement('span');span.textContent=t;return span;}));
 $('#day-number').textContent=d.days;
 $('#journey-slider').setAttribute('aria-label',d.days+' photo gallery');makeDayThumbnails();showDayPhoto(dayPhotoIndices[dayIndex]);
 if(focus)$('#day-next').focus({preventScroll:true});
}
$$('[data-day]').forEach(b=>b.addEventListener('click',()=>showDay(Number(b.dataset.day))));
$('#day-prev').addEventListener('click',()=>showDay(dayIndex-1));$('#day-next').addEventListener('click',()=>showDay(dayIndex+1));
$('#photo-prev').addEventListener('click',()=>showDayPhoto(dayPhotoIndices[dayIndex]-1));$('#photo-next').addEventListener('click',()=>showDayPhoto(dayPhotoIndices[dayIndex]+1));
$('#journey-slider').addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();showDayPhoto(dayPhotoIndices[dayIndex]+(e.key==='ArrowRight'?1:-1));}});
let journeyTouch=null,journeySwiped=false;
$('#journey-media').addEventListener('touchstart',e=>{journeyTouch={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};journeySwiped=false;},{passive:true});
$('#journey-media').addEventListener('touchend',e=>{if(!journeyTouch)return;const dx=e.changedTouches[0].clientX-journeyTouch.x,dy=e.changedTouches[0].clientY-journeyTouch.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.3){journeySwiped=true;showDayPhoto(dayPhotoIndices[dayIndex]+(dx<0?1:-1));}journeyTouch=null;},{passive:true});

function addTabKeyboard(selector,current,change,total){$(selector).addEventListener('keydown',e=>{let i=current();if(e.key==='ArrowRight')i++;else if(e.key==='ArrowLeft')i--;else if(e.key==='Home')i=0;else if(e.key==='End')i=total-1;else return;e.preventDefault();change(i,true);});}
addTabKeyboard('.feature-tabs',()=>featureIndex,showFeature,FEATURES.length);
$('#toggle-itinerary').addEventListener('click',()=>{const open=$('#full-itinerary').hidden;$('#full-itinerary').hidden=!open;$('#toggle-itinerary').setAttribute('aria-expanded',String(open));$('#toggle-itinerary').textContent=open?TOUR.labels.closeItinerary:TOUR.labels.fullItinerary;});
let selectedYear=Object.keys(DEPARTURES)[0];
const euro=value=>value===null||value===undefined?TOUR.labels.checkPrice:'€'+Number(value).toLocaleString('en-GB');
function reservationURL(d){const url=new URL(TOUR.reserveLink||'/pages/tour-registration-form',location.origin);url.search=new URLSearchParams({tour:d.slug,year:d.year,start:d.start,end:d.end,date:d.date}).toString();return url.href;}
function availabilityText(count){return Number.isInteger(count)?(count===0?'Fully booked':count+' '+(count===1?'spot':'spots')+' left'):'Check availability';}
function setYear(year){if(!DEPARTURES[year])return;selectedYear=year;const d=DEPARTURES[year];
 $$('[data-year]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.year===year)));
 $$('[data-selected-year]').forEach(e=>e.textContent=year);
 $('#booking-date').textContent=d.date;$('#fact-date').textContent=d.date;$('#bar-date').textContent=d.date+' · '+d.duration;
 $('#fact-departure-label').textContent=year===Object.keys(DEPARTURES)[0]?TOUR.labels.nextDeparture:TOUR.labels.selectedDeparture;
 $('#booking-price').textContent=d.price===null?'':euro(d.price);$('#booking-price').classList.remove('unconfirmed');
 $('#booking-price-label').replaceChildren(document.createTextNode('per person'),document.createElement('br'),document.createTextNode(year+' departure'));
 const hasPrice=d.price!==null;$('.fact-price').hidden=!hasPrice;$('.bar-price-link').hidden=!hasPrice;$('.price-row').hidden=!hasPrice;$('#fact-price').innerHTML=hasPrice?euro(d.price)+' <small>/ person</small>':'';$('#bar-price').innerHTML=hasPrice?euro(d.price)+' <small>/ person</small>':'';
 $('#fact-accommodation').textContent=d.accommodation;$('#fact-duration').textContent=d.duration;$('#fact-group').textContent=d.group;$('#fact-activity').textContent=d.activity;$('#fact-deposit').textContent=euro(d.deposit)+' deposit per person';
 $('#fact-price-check').hidden=true;$('#booking-price-check').hidden=d.priceConfirmed;$('#booking-price-check').textContent=d.priceConfirmed?'':TOUR.labels.priceConfirmation;
 const selectedDate=$('#booking-selected-date');if(selectedDate)selectedDate.textContent=d.date;
 $$('[data-spots-left]').forEach(el=>el.textContent=d.availability||availabilityText(d.spotsLeft));
 $$('[data-availability]').forEach(el=>el.dataset.availabilityTone=d.spotsLeft===null?'unknown':d.spotsLeft===0?'full':'available');
 $$('[data-availability-link]').forEach(el=>el.setAttribute('aria-label',(d.availability||availabilityText(d.spotsLeft))+' — '+TOUR.tourTitle+' '+year+', '+d.date));
 $$('[data-reserve-link]').forEach(a=>{a.href=reservationURL(d);const arrow=document.createElement('span');arrow.className='arrow';arrow.setAttribute('aria-hidden','true');arrow.textContent='↗';a.replaceChildren(document.createTextNode(d.state==='waiting'?TOUR.labels.waiting:TOUR.labels.reserve),arrow);a.dataset.departureYear=year;a.setAttribute('aria-label',TOUR.tourTitle+', '+d.date);});
 $$('[data-tour-pdf]').forEach(a=>{a.href=d.pdf;a.dataset.departureYear=year;a.setAttribute('aria-label',a.textContent.replace(/[↗↓]/g,'').trim()+' — '+TOUR.tourTitle+' '+year+', '+d.date);a.title=TOUR.tourTitle+' '+year+' · '+d.date;});
 const context=$('[data-contact-departure]');if(context)context.value=d.date;document.dispatchEvent(new CustomEvent('mr-tour:departure-change',{detail:{...d}}));
}
$$('[data-year]').forEach(b=>b.addEventListener('click',()=>setYear(b.dataset.year)));

let galleryIndex=0,lightboxPhotos=PHOTOS,lastFocus=null,lightboxDay=false;
function updateLightbox(){const p=lightboxPhotos[galleryIndex],image=$('#lb-image');image.width=p.width||1600;image.height=p.height||1000;setPhoto(image,p.src,p.alt);$('#lb-title').textContent=p.title;
 $('#lb-counter').textContent=TOUR.destination.toUpperCase()+' / '+(lightboxDay?JOURNEY[dayIndex].days.toUpperCase()+' / ':'')+String(galleryIndex+1).padStart(2,'0')+' OF '+String(lightboxPhotos.length).padStart(2,'0');
 $('#lb-caption').textContent=(p.region?p.region+' · ':'')+TOUR.labels.photoMax.toUpperCase();$('#lb-prev').hidden=lightboxPhotos.length<2;$('#lb-next').hidden=lightboxPhotos.length<2;$('.lb-middle').style.gridTemplateColumns='';$('.lb-middle').scrollTop=0;
}
function openGallery(index,dayGallery=false){lastFocus=document.activeElement;lightboxDay=dayGallery;lightboxPhotos=dayGallery?DAY_PHOTOS[dayIndex]:PHOTOS;galleryIndex=(index+lightboxPhotos.length)%lightboxPhotos.length;$('#lightbox').hidden=false;document.body.classList.add('mr-tour-locked');updateLightbox();$('#lb-close').focus();}
function closeGallery(){$('#lightbox').hidden=true;document.body.classList.remove('mr-tour-locked');if(lightboxDay)showDayPhoto(galleryIndex);if(lastFocus)lastFocus.focus({preventScroll:true});}
function stepGallery(delta){galleryIndex=(galleryIndex+delta+lightboxPhotos.length)%lightboxPhotos.length;updateLightbox();}
$$('[data-full-day-photo]').forEach(button=>button.addEventListener('click',()=>{showDay(Number(button.dataset.fullDayPhoto));openGallery(Number(button.dataset.photoIndex),true);}));
$$('[data-gallery]').forEach(b=>b.addEventListener('click',()=>openGallery(Number(b.dataset.gallery))));
$('#journey-media').addEventListener('click',()=>{if(journeySwiped){journeySwiped=false;return;}openGallery(dayPhotoIndices[dayIndex],true);});
$('#lb-close').addEventListener('click',closeGallery);$('#lb-prev').addEventListener('click',()=>stepGallery(-1));$('#lb-next').addEventListener('click',()=>stepGallery(1));$('#lightbox').addEventListener('click',e=>{if(e.target===$('#lightbox'))closeGallery();});

let startX=0,startY=0;$('#lb-image').addEventListener('touchstart',e=>{startX=e.changedTouches[0].screenX;startY=e.changedTouches[0].screenY;},{passive:true});$('#lb-image').addEventListener('touchend',e=>{const delta=e.changedTouches[0].screenX-startX,vertical=e.changedTouches[0].screenY-startY;if(Math.abs(delta)>50&&Math.abs(delta)>Math.abs(vertical))stepGallery(delta<0?1:-1);},{passive:true});
function closeMenu(){}
document.addEventListener('keydown',e=>{if(!$('#lightbox').hidden){if(e.key==='Escape')closeGallery();if(e.key==='ArrowLeft')stepGallery(-1);if(e.key==='ArrowRight')stepGallery(1);if(e.key==='Tab'){const nodes=Array.from($('#lightbox').querySelectorAll('button:not([hidden])'));const first=nodes[0],last=nodes[nodes.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}}else if(e.key==='Escape')closeMenu();});
const navLinks=$$('.subnav a').filter(a=>a.hash&&a.hash!=='#top');const sections=navLinks.map(a=>$(a.hash)).filter(Boolean);let scrollQueued=false;
function onScroll(){const top=window.scrollY;const total=document.documentElement.scrollHeight-window.innerHeight;$('#progress').style.width=(total>0?Math.min(100,top/total*100):0)+'%';document.body.classList.toggle('bar-visible',top>$('#overview').offsetTop-90);let active=sections[0];sections.forEach(s=>{if(s.getBoundingClientRect().top<170)active=s;});navLinks.forEach(a=>a.classList.toggle('current',a.hash==='#'+active.id));scrollQueued=false;}
window.addEventListener('scroll',()=>{if(!scrollQueued){scrollQueued=true;requestAnimationFrame(onScroll);}},{passive:true});window.addEventListener('resize',onScroll);onScroll();
let reviewIndex=0;
function showReview(index){const slides=$$('.review-slide');if(!slides.length)return;reviewIndex=(index+slides.length)%slides.length;slides.forEach((el,i)=>el.hidden=i!==reviewIndex);$('#review-count').textContent=String(reviewIndex+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');const progress=$('#review-progress-fill');if(progress)progress.style.width=((reviewIndex+1)/slides.length*100)+'%';}
showReview(0);
$('#review-prev')?.addEventListener('click',()=>showReview(reviewIndex-1));$('#review-next')?.addEventListener('click',()=>showReview(reviewIndex+1));
$('.review-content')?.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();showReview(reviewIndex+(e.key==='ArrowRight'?1:-1));}});
let reviewTouch=null;$('.review-viewport')?.addEventListener('touchstart',e=>{reviewTouch={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};},{passive:true});$('.review-viewport')?.addEventListener('touchend',e=>{if(!reviewTouch)return;const dx=e.changedTouches[0].clientX-reviewTouch.x,dy=e.changedTouches[0].clientY-reviewTouch.y;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.3)showReview(reviewIndex+(dx<0?1:-1));reviewTouch=null;},{passive:true});


const tourMenu = $('#all-tours-menu');
const tourMenuTriggers = $$('[data-open-tour-menu]');
let lastTourMenuTrigger = null;
function closeTourMenu(){if(tourMenu.open)tourMenu.close();}
function openTourMenu(event){
  lastTourMenuTrigger=event.currentTarget;
  closeMenu();
  if(!$('#lightbox').hidden)closeGallery();
  if(!tourMenu.open)tourMenu.showModal();
  document.body.classList.add('mr-tour-locked');
  tourMenuTriggers.forEach(button=>button.setAttribute('aria-expanded','true'));
}
tourMenuTriggers.forEach(button=>button.addEventListener('click',openTourMenu));
$('#close-all-tours').addEventListener('click',closeTourMenu);
tourMenu.addEventListener('close',()=>{
  tourMenuTriggers.forEach(button=>button.setAttribute('aria-expanded','false'));
  if($('#lightbox').hidden)document.body.classList.remove('mr-tour-locked');
  const fallback=lastTourMenuTrigger?.classList.contains('header-tour-trigger')&&$('#menu-toggle')?.getClientRects().length?$('#menu-toggle'):$('.tour-menu-trigger');
  const focusTarget=lastTourMenuTrigger?.getClientRects().length?lastTourMenuTrigger:fallback;
  focusTarget?.focus({preventScroll:true});
});
tourMenu.addEventListener('click',event=>{
  if(event.target!==tourMenu)return;
  const box=tourMenu.getBoundingClientRect();
  if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)closeTourMenu();
});
$$('#all-tours-menu a').forEach(link=>link.addEventListener('click',event=>{
  if(event.button>0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  const current=link.hasAttribute('data-current-tour');
  if(current)event.preventDefault();
  closeTourMenu();
  if(current)requestAnimationFrame(()=>$('#overview').scrollIntoView({behavior:motion,block:'start'}));
}));



const contactForm=$('#tour-contact-form');
['contact-name','contact-message'].forEach(id=>{const field=$('#'+id);field.addEventListener('input',()=>field.setCustomValidity(''));});
contactForm?.addEventListener('submit',event=>{for(const id of ['contact-name','contact-message']){const field=$('#'+id);if(!field.value.trim()){event.preventDefault();field.setCustomValidity(field.id==='contact-name'?'Please enter your name.':'Please write a message.');field.reportValidity();return;}}});
showDay(0);
let initialYear=Object.keys(DEPARTURES)[0];try{const q=new URL(location.href).searchParams.get("year");if(DEPARTURES[q])initialYear=q;}catch(e){}setYear(initialYear);
root.TOUR_PREVIEW={departures:DEPARTURES,dayPhotos:DAY_PHOTOS,setYear,showDay,showDayPhoto,showReview,showGuide,scrollHighlights};

root.dataset.ready='true';}document.querySelectorAll('[data-mr-tour]').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mr-tour]').forEach(init));})();

/* Native lazy images + one-time, image-ready homepage reveals. No dependencies. */
(() => {
  'use strict';
  if (window.peruTourRevealMounted) return;
  window.peruTourRevealMounted = true;

  const pending = 'mr-home-reveal-pending';
  const entering = 'mr-home-reveal-enter';
  const selector = [
    '.departure-overview', '.intro-story', '.peru-intro-map', '.section-head', '.gallery-tile', '.gallery-foot',
    '.feature-tabs', '.feature-panel', '.feature-bottom', '.day-tabs', '.journey-panel',
    '.guide-grid', '.review-intro', '.review-content', '.inclusion-col', '.faq-left', '.faq-list',
    '.departure-copy', '.booking-card', '.tour-contact-intro', '.tour-contact-form', '.section-background',
    '.related-card'
  ].join(',');
  const seen = new WeakSet();
  const waiting = new Set();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let failed = false;
  const canAnimate = () => !failed && !motion.matches &&
    'IntersectionObserver' in window && !window.Shopify?.designMode;

  function showImmediately(element) {
    waiting.delete(element);
    observer?.unobserve(element);
    element.classList.remove(pending, entering);
    element.style.removeProperty('--mr-home-reveal-delay');
  }

  function showAll() {
    observer?.disconnect();
    document.querySelectorAll('.' + pending + ',.' + entering).forEach(showImmediately);
  }

  function imageReady(img) {
    // A loading failure must never hide the text or controls around an image.
    return new Promise(resolve => {
      let settled = false;
      let timer;
      const done = () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        img.removeEventListener('load', loaded);
        img.removeEventListener('error', done);
        resolve();
      };
      const loaded = () => {
        if (typeof img.decode === 'function') img.decode().then(done, done);
        else done();
      };
      timer = setTimeout(done, 1500);
      if (img.complete) { loaded(); return; }
      img.addEventListener('load', loaded, { once: true });
      img.addEventListener('error', done, { once: true });
      // Only promote images whose reveal has reached the viewport.
      img.loading = 'eager';
    });
  }

  function reveal(element, delay) {
    observer?.unobserve(element);
    if (!waiting.has(element)) return;
    if (!canAnimate()) { showImmediately(element); return; }
    const images = (element.matches('img') ? [element] : Array.from(element.querySelectorAll('img'))).filter(img =>
      !img.closest('[hidden]') && img.getClientRects().length &&
      (img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset'))
    );
    Promise.all(images.map(imageReady)).then(() => {
      if (!waiting.has(element) || !element.isConnected) return;
      if (!canAnimate()) { showImmediately(element); return; }
      waiting.delete(element);
      element.style.setProperty('--mr-home-reveal-delay', delay + 'ms');
      element.classList.remove(pending);
      element.classList.add(entering);
      // Remove animation styles after the photo settles so hover stays independent.
      setTimeout(() => {
        element.classList.remove(entering);
        element.style.removeProperty('--mr-home-reveal-delay');
      }, 2700 + delay);
    }).catch(() => showImmediately(element));
  }

  function init(scope) {
    const main = document.querySelector('main');
    if (!main) return;
    // Loading is declared in Liquid before parsing; decoding is enhanced here.
    // The opening hero and its slideshow stay eager and never receive reveal classes.
    main.querySelectorAll('img[loading="lazy"]').forEach(img => { img.decoding = 'async'; });
    if (!canAnimate()) return;
    try {
      if (!observer) observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top ||
            a.boundingClientRect.left - b.boundingClientRect.left);
        let rowTop = -Infinity;
        let parent = null;
        let step = 0;
        visible.forEach(entry => {
          const element = entry.target;
          if (element.matches('.gallery-tile') && element.parentElement === parent &&
              Math.abs(entry.boundingClientRect.top - rowTop) < 60) step++;
          else { step = 0; rowTop = entry.boundingClientRect.top; parent = element.parentElement; }
          reveal(element, Math.min(step, 3) * 150);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -56px 0px' });

      const candidates = Array.from(scope.querySelectorAll(selector));
      if (scope.matches?.(selector)) candidates.unshift(scope);
      const measurements = candidates.filter(element => main.contains(element) && !seen.has(element))
        .map(element => ({element, rect:element.getBoundingClientRect()}));
      measurements.forEach(({element, rect}) => {
        if (!main.contains(element) || seen.has(element)) return;
        seen.add(element);
        // Preserve already-visible content and restored scroll positions.
        if (!rect.height || rect.top < window.innerHeight) return;
        waiting.add(element);
        element.classList.add(pending);
        observer.observe(element);
      });
    } catch (_) {
      failed = true;
      showAll();
    }
  }

  window.addEventListener('error', showAll);
  window.addEventListener('unhandledrejection', showAll);
  const boot = () => document.querySelectorAll('[data-mr-tour]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    waiting.forEach(element => { if (event.target.contains(element)) showImmediately(element); });
  });
  document.addEventListener('focusin', event => {
    const element = event.target.closest?.('.' + pending + ',.' + entering);
    if (element) showImmediately(element);
  });
  // Search, keyboard navigation, printing and reduced motion always expose content.
  document.addEventListener('beforematch', showAll);
  window.addEventListener('beforeprint', showAll);
  window.addEventListener('pageshow', event => { if (event.persisted) showAll(); });
  if (motion.addEventListener) motion.addEventListener('change', () => {
    if (motion.matches) showAll();
  });
})();

(() => {
  const desktop = window.matchMedia('(min-width: 1200px)');
  let observedHeader = null;
  const observer = 'ResizeObserver' in window ? new ResizeObserver(syncHeaderOffset) : null;

  function syncHeaderOffset() {
    if (!document.querySelector('[data-mr-tour]')) return;
    const header = document.querySelector('#shopify-section-header .site-header');
    if (header !== observedHeader) {
      observer?.disconnect();
      if (header) observer?.observe(header);
      observedHeader = header;
    }
    let offset = 0;
    if (desktop.matches && header) {
      const style = getComputedStyle(header);
      if (style.display !== 'none' && (style.position === 'fixed' || style.position === 'sticky')) {
        offset = Math.max(0, Math.ceil(header.getBoundingClientRect().bottom));
      }
    }
    document.documentElement.style.setProperty('--mr-tour-header-offset', offset + 'px');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncHeaderOffset, {once: true});
  else syncHeaderOffset();
  window.addEventListener('resize', syncHeaderOffset, {passive: true});
  document.addEventListener('shopify:section:load', syncHeaderOffset);
  desktop.addEventListener('change', syncHeaderOffset);
})();
